import { StrongText } from '@dreryk/react-components';

type DeviceRemoveCellDeviceNameProps = {
   readonly deviceName: string;
};

export const DeviceRemoveCellDeviceName = (props: DeviceRemoveCellDeviceNameProps): JSX.Element => {
   return <StrongText testId={'deviceName'}>{props.deviceName}</StrongText>;
};
